import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(
  ({ theme }) => `
  max-width: 1180px;
  margin: 0 auto;
  .MuiGrid-item.side-bar {
    -webkit-flex-basis: 316px;
    -ms-flex-preferred-size: 316px;
    flex-basis: 316px;
    -webkit-box-flex: 0;
    -webkit-flex-grow: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 100%;
  }
  .MuiGrid-item.main-content {
    padding-left: 0;
    -webkit-flex-basis: 880px;
    -ms-flex-preferred-size: 880px;
    flex-basis: 880px;
    -webkit-box-flex: 0;
    -webkit-flex-grow: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 880px;
  }
  ${theme.breakpoints.down('lg')} {
    .MuiGrid-item.main-content {
      padding-left: 16px;
      -webkit-flex-basis: 100%;
      -ms-flex-preferred-size: 100%;
      flex-basis: 100%;
      -webkit-box-flex: 0;
      -webkit-flex-grow: 0;
      -ms-flex-positive: 0;
      flex-grow: 0;
      max-width: 100%;
    }
  }
`,
);
